import bk from "../../../assets/imgs/class/bk.gif";
import sm from "../../../assets/imgs/class/sm.gif";
import elf from "../../../assets/imgs/class/elf.gif";
import mg from "../../../assets/imgs/class/mg.gif";
import dl from "../../../assets/imgs/class/dl.gif";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../../store/reducers/reducerUser";
import PanelFrame from "../../ui/PanelFrame";
import SiteButton from "../../ui/SiteButton";
import { useLang } from "../../../i18n/LangContext";
import "./sidebarProfile.scss";

const Profile = ({ user }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useLang();
  const matches = useMediaQuery("(max-width:600px)");

  const goTo = () => {
    window.scrollTo(0, matches ? 500 : 500);
  };

  const webImg = user?.data?.data?.[0]?.webImg;
  const avatar =
    (webImg === "1" && bk) ||
    (webImg === "2" && sm) ||
    (webImg === "3" && elf) ||
    (webImg === "4" && mg) ||
    (webImg === "5" && dl) ||
    bk;

  const bcoin = user?.data?.data?.[0]?.BCoin ?? 0;
  const credits = user?.data?.data?.[0]?.Credits ?? 0;

  return (
    <PanelFrame title={t("my_account")}>
      <div className="mu-user-panel">
        <div className="mu-user-panel__row">
          <img className="mu-user-panel__avatar" src={avatar} alt="profile" />
          <nav className="mu-user-panel__nav">
            <Link onClick={goTo} to="/profile" className="mu-user-panel__link">
              {t("account_details")}
            </Link>
            <Link
              onClick={goTo}
              to="/buyCredits"
              className="mu-user-panel__link"
            >
              {t("buy_bcoin")}
            </Link>
            <Link onClick={goTo} to="/vote" className="mu-user-panel__link">
              {t("vote_now")}
            </Link>
            <Link onClick={goTo} to="/players" className="mu-user-panel__link">
              {t("my_characters")}
            </Link>
          </nav>
        </div>

        <div className="mu-user-panel__footer">
          <div className="mu-user-panel__balances">
            <div className="mu-user-panel__credits">BCoin: {bcoin}</div>
            <div className="mu-user-panel__credits">Credits: {credits}</div>
          </div>
          <SiteButton
            variant="secondary"
            className="mu-user-panel__logout"
            onClick={() => {
              dispatch(logout());
              navigate("/");
            }}
          >
            {t("logout")}
          </SiteButton>
        </div>
      </div>
    </PanelFrame>
  );
};

export default Profile;
